import { createContext } from "react";

// Create default shape for each field
export const EntityManagementContext = createContext({
    editingID: -1,
    setEditingID: () => {},
    mode: "",
    setMode: () => {},
    exit: () => {},
    type: "",
    classes: [],
    setClasses: () => {},
    teachers: [],
    setTeachers: () => {},
    students: [],
    setStudents: () => {},
    admins: [],
    setAdmins: () => {},
    openPopup: () => {},
    updateEntities: () => {}
})